import { Box, styled } from '@ltvco/refresh-lib/theme';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';

export const StepRow = styled(Box)(({ theme }) => ({
  '@keyframes chevronPop': {
    '0%': { transform: 'scale(1)' },
    '45%': { transform: 'scale(1.25)' },
    '100%': { transform: 'scale(1)' },
  },
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  width: '100%',
  minHeight: 44,
  cursor: 'pointer',
  padding: '6px 0',
  color: theme.palette.text.primary,
  transition: 'color 0.12s ease',
  '&:hover': {
    color: theme.palette.primary.main,
    textDecoration: 'underline dotted',
    '& .followup-arrow': {
      color: theme.palette.primary.main,
      animation: 'chevronPop 0.6s ease forwards',
    },
  },
}));

export const ArrowIcon = styled(SubdirectoryArrowRightIcon)(({ theme }) => ({
  color: theme.palette.text.primary,
  transition: 'color 0.12s ease',
  fontSize: '16px !important',
  flexShrink: 0,
}));
